import { cloneLocationFilters } from "./locationFilterUtils";
import { mergeSelectedIdMap } from "./mergeSelectedIdMap";
import { EMPTY_MY_VENDORS_SELECTED_IDS } from "./myVendorsFilterOptions";
import { EMPTY_VENDOR_LIST_VIEW_SELECTED_IDS } from "./myVendorListViewUtils";
import { mergePositivePageNumber } from "./stickyFilterMergeUtils";
import {
  clearStickyFilters,
  loadStickyFilters,
  saveStickyFilters,
} from "./stickyFilterStorage";

export const VENDOR_STICKY_SCREEN_KEYS = {
  DISCOVERY: "vendorDiscovery",
  MY_VENDORS_MINE: "myVendorsMine",
  MY_VENDORS_LISTS: "myVendorsLists",
};

export function getVendorListDetailStickyKey(listId) {
  return listId ? `vendorListDetail:${listId}` : "vendorListDetail";
}

export function createEmptyDiscoveryVendorFilters() {
  return {
    selectedVendors: [],
    selectedCategories: [],
    selectedVendorType: [],
    selectedTAIndications: {},
    selectedDocAvail: [],
    selectedDataAvailability: [],
    selectedEmployeeSizes: [],
    selectedRevenueRanges: [],
    locationFilters: cloneLocationFilters(null),
  };
}

function mergeOptionArray(saved) {
  if (!Array.isArray(saved)) {
    return [];
  }

  return saved.filter((item) => item != null && typeof item === "object");
}

function mergeSortDirection(saved) {
  return saved === "asc" || saved === "desc" ? saved : null;
}

/**
 * Hydrates My Vendors (mine / lists tab) sticky selectedIds.
 */
export function loadMyVendorsStickyFilterState(screenKey) {
  const saved = loadStickyFilters(screenKey);
  return {
    selectedIds: mergeSelectedIdMap(
      saved?.selectedIds,
      EMPTY_MY_VENDORS_SELECTED_IDS
    ),
  };
}

/**
 * Hydrates vendor list detail sticky selectedIds.
 */
export function loadVendorListDetailStickyFilterState(screenKey) {
  const saved = loadStickyFilters(screenKey);
  return {
    selectedIds: mergeSelectedIdMap(
      saved?.selectedIds,
      EMPTY_VENDOR_LIST_VIEW_SELECTED_IDS
    ),
  };
}

/**
 * Hydrates Vendor Discovery filter UI + grid sort/pagination from sessionStorage.
 */
export function loadDiscoveryStickyFilterState(
  screenKey = VENDOR_STICKY_SCREEN_KEYS.DISCOVERY
) {
  const saved = loadStickyFilters(screenKey);
  const vendorFilters = saved?.vendorFilters;

  return {
    vendorFilters: {
      selectedVendors: mergeOptionArray(vendorFilters?.selectedVendors),
      selectedCategories: mergeOptionArray(vendorFilters?.selectedCategories),
      selectedVendorType: mergeOptionArray(vendorFilters?.selectedVendorType),
      selectedTAIndications:
        vendorFilters?.selectedTAIndications &&
        typeof vendorFilters.selectedTAIndications === "object" &&
        !Array.isArray(vendorFilters.selectedTAIndications)
          ? vendorFilters.selectedTAIndications
          : {},
      selectedDocAvail: mergeOptionArray(vendorFilters?.selectedDocAvail),
      selectedDataAvailability: mergeOptionArray(
        vendorFilters?.selectedDataAvailability
      ),
      selectedEmployeeSizes: mergeOptionArray(
        vendorFilters?.selectedEmployeeSizes
      ),
      selectedRevenueRanges: mergeOptionArray(
        vendorFilters?.selectedRevenueRanges
      ),
      locationFilters: cloneLocationFilters(vendorFilters?.locationFilters),
    },
    sortColumn:
      typeof saved?.sortColumn === "string" && saved.sortColumn
        ? saved.sortColumn
        : null,
    sortDirection: mergeSortDirection(saved?.sortDirection),
    currentPage: mergePositivePageNumber(saved?.currentPage),
  };
}

/** Persists filter state for a vendor sticky screen (merge-friendly partial OK). */
export function persistVendorStickyFilterState(screenKey, filterState) {
  if (!screenKey || !filterState) {
    return;
  }

  const existing = loadStickyFilters(screenKey) || {};
  saveStickyFilters(screenKey, { ...existing, ...filterState });
}

export function clearVendorStickyFilterState(screenKey) {
  clearStickyFilters(screenKey);
}
